import { render, staticRenderFns } from "./CopyLabel.vue?vue&type=template&id=6abe243f&scoped=true&"
import script from "./CopyLabel.vue?vue&type=script&lang=js&"
export * from "./CopyLabel.vue?vue&type=script&lang=js&"
import style0 from "./CopyLabel.vue?vue&type=style&index=0&id=6abe243f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abe243f",
  null
  
)

export default component.exports